<!--
 * @Author: zhanghan
 * @Date: 2021-01-23 21:55:45
 * @LastEditors: zhanghan
 * @LastEditTime: 2021-02-26 23:31:22
 * @Descripttion:
-->
<template>
  <div class="sidebar">
    <v-catalogue
      @getColumnArticle="getColumnArticle"
      :categories="categories"
      :nowCategorie="nowCategorie"
    ></v-catalogue>
    <v-blogTags
      @toTag="toTag"
      :tags="tags"
      :nowTagName="nowTagName"
    ></v-blogTags>
  </div>
</template>

<script>
import Catalogue from "@/components/common/catalogue/catalogue";
import blogTags from "@/components/common/blogTags/blogTags";

export default {
  props: {
    categories: {
      type: Array
    },
    tags: {
      type: Array
    },
    nowCategorie: {
      type: String,
      default: ""
    },
    nowTagName: {
      type: String,
      default: ""
    }
  },
  components: {
    "v-catalogue": Catalogue,
    "v-blogTags": blogTags
  },
  methods: {
    getColumnArticle(col) {
      this.$emit("getColumnArticle", col);
    },
    toTag(itemTag) {
      this.$emit("toTag", itemTag);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.sidebar {
  width: 250px;
  /*float: right;*/
  position: fixed;
  left: 50%;
  margin-left: 250px;
  top: 70px;
  padding-top: 34px;
}
@media (max-width: 1024px) {
  .sidebar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// sidebar.vue?032d5eea